import {CartItem} from '@/types/CartItem'
import {Buyer} from '@/types/Buyer'
import {AssignConstructor} from '@/types/AssignConstructor'

export class Order extends AssignConstructor {
    id: number | undefined
    basket: Array<CartItem> | undefined
    orderBuyer: Buyer | undefined
}
